import React from 'react';
import PropTypes from 'prop-types';
import { FilmIcon } from '@heroicons/react/solid';
import { useTranslation } from 'react-i18next';

export function Panel(props) {
  const { item } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 mt-24">
      <video controls>
        <source src={item.content.url} type="video/mp4" />
      </video>
    </div>
  );
}

Panel.propTypes = {
  item: PropTypes.objectOf({
    content: PropTypes.objectOf({
      question: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  setItem: PropTypes.func.isRequired,
};

export function Preview(props) {
  const { selected } = props;
  const { t } = useTranslation();
  return (
    <div
      className={`h-full w-full text-sky mx-auto bg-grey-super_light rounded-md border-sky  ${
        selected ? 'opacity-100 border-3' : 'opacity-50 border-2'
      }`}
    >
      <FilmIcon className="h-10 w-10 text-sky mx-auto mt-8" />
      <p>{t('courses.mp4_file')}</p>
    </div>
  );
}

Preview.propTypes = {
  selected: PropTypes.bool.isRequired,
};
